import { axiosWithAuth } from "helpers";
import { Fees } from "types";

export const merchantFeesService = {
	getFees,
	updateFees,
};

const API_URL = process.env.REACT_APP_API_URL;

type UpdateFeesProps = {
	merchantId: string;
	fees: Fees;
};

type GetFeesProps = {
	merchantId: string;
};
function getFees({ merchantId }: GetFeesProps): Promise<Fees | Error> {
	const options = {
		method: "GET",
		url: `${API_URL}/api/merchants/${merchantId}/fees`,
	};

	return axiosWithAuth(options);
}

function updateFees({
	merchantId,
	fees,
}: UpdateFeesProps): Promise<void | Error> {
	const options = {
		method: "POST",
		data: fees,
		url: `${API_URL}/api/merchants/${merchantId}/fees`,
	};

	return axiosWithAuth(options);
}
